import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import Image from '../atoms/Image';
import DialogHeader from './DialogHeader';
import type { Persona } from '../../data/Personas';
import { getImageByKey } from '../../assets/Assets';

const Container = styled.div`
	overflow: visible;
`;

const Name = styled.span`
	bottom: 0;
	color: ${(props) => props.theme.colors.veryLightBlue};
	display: inline-block;
	font: ${(props) => props.theme.font.title};
	font-size: 18vmin;
	left: calc(11% + 38vmin - 0.2em);
	line-height: 0.6;
	position: absolute;
	transform: rotate(-10deg);
	transform-origin: bottom left;
`;

export interface Props {
	persona: Persona;
}

const PersonaDetailsOverlay: FunctionComponent<Props> = (props: Props) => {
	const { persona } = props;

	return (
		<Container>
			<DialogHeader>
				<Trans tOptions={{ returnObjects: true }}>{persona.texts.title}</Trans>
			</DialogHeader>
			<Image
				src={getImageByKey(persona.images.body.positive)}
				width="38vmin"
				height="55.6vmin"
				position="absolute"
				left="11%"
				bottom="0"
			/>
			<Name>
				<Trans>{persona.texts.name}</Trans>
			</Name>
		</Container>
	);
};

export default PersonaDetailsOverlay;
